//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA LOAD USERS SERVICE ---------------//
// Responsável por requisitar à API os Usuários existentes
export default async function loadGroupsProductsService() {
    try {
        const response = await api.get("/grupos-produtos");
        return response;
    } catch (err) {
        toast.error("Erro ao carregar grupos de produtos");
        return null;
    }
}